export const SUGGESTED_VARIABLES = [
  "nome_paciente",
  "nome_clinica",
] as const;

export type RichTextActionKey =
  | "bold"
  | "italic"
  | "strikethrough"
  | "monospace";

export const RICH_TEXT_ACTIONS = [
  {
    key: "bold",
    label: "Negrito",
    hint: "*texto*",
  },
  {
    key: "italic",
    label: "Itálico",
    hint: "_texto_",
  },
  {
    key: "strikethrough",
    label: "Tachado",
    hint: "~texto~",
  },
  {
    key: "monospace",
    label: "Monoespaçado",
    hint: "```texto```",
  },
] as const;

export const DEFAULT_WHATSAPP_TEMPLATE_LANGUAGE = "pt_BR";
export const DEFAULT_WHATSAPP_TEMPLATE_CATEGORY = "MARKETING";
export const DEFAULT_MESSAGE_TEMPLATES_ROWS_PER_PAGE = 6;

export const DEFAULT_WHATSAPP_BUSINESS_ACCOUNT_ID = "369757892878978";

export { CHAT_BG_PATTERN, URL_BUTTON_COLOR } from "./phonePreview";